<template>
  <div class="mb-2">
    <p class="font-w600">MPAN</p>
    <p>{{ item.selectedAccount.meterPointNumber || '-' }}</p>
  </div>
  <div class="mb-2">
    <p class="font-w600">Meter Name</p>
    <p>
      {{ item.selectedAccount.name || '-' }}
    </p>
  </div>
  <div class="mb-2">
    <p class="font-w600">Serial No.</p>
    <p>{{ item.selectedAccount.meterPointNumber || '-' }}</p>
  </div>
  <div class="mb-2" v-if="item.selectedAccount.deviceId">
    <p class="font-w600">Device ID</p>
    <p>{{ item.selectedAccount.deviceId }}</p>
  </div>

  <div class="mb-2">
    <p class="font-w600">Type</p>
    <p class="text-capitalize">
      {{ item.selectedAccount.type }}
      <span v-if="item.selectedAccount.parentAccount">(Sub-meter)</span>
    </p>
  </div>

  <div class="mb-2" v-if="item.selectedAccount.parentAccount">
    <p class="font-w600">Parent Account</p>
    <p>
      [{{ item.selectedAccount.parentAccount.meterPointNumber || '-' }}]
      {{ item.selectedAccount.parentAccount.name }}
    </p>
  </div>

  <div class="mb-2">
    <p class="font-w600">Location</p>
    <p>{{ item.selectedAccount.meterLocation || '-' }}</p>
  </div>

  <div class="mb-2">
    <p class="font-w600">Site</p>
    <p>{{ item.selectedAsset.siteName }}<br />{{ item.selectedAsset.addressString }}</p>
  </div>
</template>
<script lang="ts" setup>
import type { WizardFullState } from '@/stores/queue';

defineProps<{
  item: WizardFullState;
}>();
</script>
